import * as React from 'react'
import { SVGProps } from 'react'

const GenderMaleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={40} {...props}>
    <defs>
      <clipPath id="GenderMaleIcon">
        <path
          data-name="Rectangle 9311"
          transform="translate(1033 1130)"
          fill="none"
          stroke="#707070"
          d="M0 0h48v40H0z"
        />
      </clipPath>
    </defs>
    <g data-name="Mask Group 549" transform="translate(-1033 -1130)" clipPath="url(#GenderMaleIcon)">
      <g data-name="Group 58538">
        <g data-name="Group 58537">
          <g data-name="Group 58536" fill="#263238">
            <path data-name="Path 86928" d="m1064.88 1144.95-1.273-1.273 7.778-7.779 1.273 1.273Z" />
            <path data-name="Path 86929" d="m1073.558 1142.865-1.785.195-.63-5.646-5.646-.63.195-1.785 7.082.784Z" />
          </g>
        </g>
        <path
          data-name="Ellipse 1776"
          d="M1056.5 1142.892a10.7 10.7 0 0 0-7.566 18.266 10.7 10.7 0 1 0 15.132-15.132 10.63 10.63 0 0 0-7.566-3.134m0-1.8a12.5 12.5 0 1 1-12.5 12.5 12.5 12.5 0 0 1 12.5-12.5Z"
          fill="#263238"
        />
      </g>
    </g>
  </svg>
)

export default GenderMaleIcon
